import React from 'react'

// Styles
import classes from 'components/Onboarding/DataDisclaimer/DataDisclaimer.module.scss'

// Icons
import { ReactComponent as DataLock } from 'assets/icons/onboarding/green_lock.svg'

export default function DataDisclaimer() {
  return (
    <div className={classes.container}>
      <div className={classes.icon}>
        <DataLock />
      </div>
      <p className={classes.text}>
        <span className="fw-semibold">Your data is safe with us.</span> We’ll
        never make any changes to your accounts without your explicit
        permission. You can revoke access at any time.
      </p>
    </div>
  )
}
